import { createSlice } from "@reduxjs/toolkit";

const UserPreferenceSlice = createSlice({
  name: "UserPreferenceSlice",
  initialState: {
    userSettings: {}
  },
  reducers: {
    UserSettingsReducer: (state: any, action: any) => {
      state.userSettings = action.payload;
      return state;
    }
  }
});

export const { UserSettingsReducer } = UserPreferenceSlice.actions;

export default UserPreferenceSlice;
